/*
  eslint
  no-param-reassign: ["error", { "props": false }]
  no-console: "off"
*/
import Vue from 'vue';
import LIST_ASSETS from './queries/listAssets.gql';
import GET_ASSET from './queries/getAsset.gql';
import LIST_ANALYTICS from './queries/listAnalytics.gql';
import GET_ANALYTIC from './queries/getAnalytic.gql';
import LIST_PROFILES from './queries/listProfiles.gql';
import GET_PROFILE from './queries/getProfile.gql';
import CREATE_ANALYTIC from './mutations/createAnalytic.gql';
import UPDATE_ANALYTIC from './mutations/updateAnalytic.gql';
import DELETE_ANALYTIC from './mutations/deleteAnalytic.gql';
import CREATE_PROFILE from './mutations/createProfile.gql';
import UPDATE_PROFILE from './mutations/updateProfile.gql';
import DELETE_PROFILE from './mutations/deleteProfile.gql';
import GET_ORGANIZATION from './queries/getOrganization.gql';
import SET_PROFILE_ANALYTICS from './mutations/setProfileAnalytics.gql';
import SET_ASSET_PROFILE from './mutations/setAssetProfile.gql';
import GET_CONFIG from './queries/getConfig.gql';
import DELETE_ASSET from './mutations/deleteAsset.gql';
import LIST_ALERTS from './queries/listAlerts.gql';
import GET_ALERT from './queries/getAlert.gql';
import GET_ACTION_CONFIGS from './queries/getActionConfigs.gql';
import LIST_ACTION_CONFIGS from './queries/listActionConfigs.gql';
import CREATE_ACTION_CONFIGS from './mutations/createActionConfigs.gql';
import UPDATE_ACTION_CONFIGS from './mutations/updateActionConfigs.gql';
import DELETE_ACTION_CONFIGS from './mutations/deleteActionConfigs.gql';
import LIST_ALERTS_STATS from './queries/listAlertsStats.gql';
import LIST_LOGS_STATS from './queries/listLogsStats.gql';
import LIST_ALERTS_TAGS from './queries/listAlertsTags.gql';
import LIST_LOGS_TAGS from './queries/listLogsTags.gql';
import LIST_LOGS from './queries/listLogs.gql';
import GET_LOG from './queries/getLog.gql';
import GET_DEPLOYMENT from './queries/getDeployment.gql';
import LIST_DEPLOYMENTS from './queries/listDeployments.gql';
import LIST_PACKAGES from './queries/listPackages.gql';
import GET_PACKAGE from './queries/getPackage.gql';
import CREATE_DEPLOYMENT from './mutations/createDeployment.gql';
import GET_DEPLOYMENT_DOWNLOAD_URL from './queries/getDeploymentDownloadURL.gql';
import DELETE_DEPLOYMENT from './mutations/deleteDeployment.gql';
import LIST_ANALYTIC_CATEGORIES from './queries/listAnalyticsCategories.gql';
import LIST_ANALYTIC_TAGS from './queries/listAnalyticsTags.gql';
import GET_MAPKIT_KEY from './queries/getMapKitKey.gql';
import GET_KEYVALUE from './queries/getKeyValue.gql';
import CREATE_OR_UPDATE_KEYVALUE from './mutations/createOrUpdateKeyValue.gql';
import UPDATE_ASSET from './mutations/updateAsset.gql';
import LIST_ASSETS_STATS from './queries/listAssetsStats.gql';

const PrimaryStoreModule = {
  namespaced: true,
  state: {
    assets: [],
    assetsNextToken: null,
    asset: null,
    deployments: [],
    deploymentsNextToken: null,
    deployment: null,
    analytics: [],
    analyticsNextToken: null,
    analytic: null,
    profiles: [],
    profilesNextToken: null,
    profile: null,
    organization: null,
    actionConfigss: [],
    actionConfigssNextToken: null,
    actionConfigs: null,
    keyValues: {},
  },
  mutations: {
    SET_KEYVALUE(state, payload) {
      state.keyValues[payload.key] = payload.value;
    },
    SET_ORGANIZATION(state, payload) {
      state.organization = payload;
    },
    SET_ASSET(state, payload) {
      state.asset = payload;
    },
    SET_ASSETS(state, payload) {
      state.assets = payload.items;
      state.assetsNextToken = payload.nextToken;
    },
    SET_DEPLOYMENT(state, payload) {
      state.deployment = payload;
    },
    SET_DEPLOYMENTS(state, payload) {
      state.deployments = payload.items;
      state.deploymentsNextToken = payload.nextToken;
    },
    SET_ANALYTIC(state, payload) {
      state.analytic = payload;
    },
    SET_ANALYTICS(state, payload) {
      state.analytics = payload.items;
      state.analyticsNextToken = payload.nextToken;
    },
    SET_PROFILE(state, payload) {
      if (typeof payload.infoSync === 'string') {
        payload.infoSync = JSON.parse(payload.infoSync);
      }
      state.profile = payload;
    },
    SET_PROFILES(state, payload) {
      state.profiles = payload.items;
      state.profilesNextToken = payload.nextToken;
    },
    SET_ACTION_CONFIGS(state, payload) {
      state.actionConfigs = payload;
      if (state.actionConfigs) {
        state.actionConfigs.logConfig = JSON.parse(state.actionConfigs.logConfig);
        state.actionConfigs.alertConfig = JSON.parse(state.actionConfigs.alertConfig);
        state.actionConfigs.cacheConfig = JSON.parse(state.actionConfigs.cacheConfig);
      }
    },
    SET_ACTION_CONFIGSS(state, payload) {
      state.actionConfigss = payload.items;
      state.actionConfigssNextToken = payload.nextToken;
    },
  },
  getters: {},
  actions: {
    async deleteProfile({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: DELETE_PROFILE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_PROFILE', result.data.deleteProfile);
        return result.data.deleteProfile;
      }
      return result;
    },
    async updateProfile({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: UPDATE_PROFILE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_PROFILE', result.data.updateProfile);
        return result.data.updateProfile;
      }
      return result;
    },
    async createProfile({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: CREATE_PROFILE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_PROFILE', result.data.createProfile);
        return result.data.createProfile;
      }
      return result;
    },
    async deleteAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: DELETE_ANALYTIC,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ANALYTIC', result.data.deleteAnalytic);
        return result.data.deleteAnalytic;
      }
      return result;
    },
    async updateAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: UPDATE_ANALYTIC,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ANALYTIC', result.data.updateAnalytic);
        return result.data.updateAnalytic;
      }
      return result;
    },
    async createAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: CREATE_ANALYTIC,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ANALYTIC', result.data.createAnalytic);
        return result.data.createAnalytic;
      }
      return result;
    },
    async createDeployment({ dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: CREATE_DEPLOYMENT,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.createDeployment;
      }
      return result;
    },
    async getAsset({ commit, dispatch }, payload) {
      // TODO: try to grab it from local list?
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_ASSET,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ASSET', result.data.getAsset);
        return result.data.getAsset;
      }
      return result;
    },
    async listAssets({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ASSETS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ASSETS', result.data.listAssets);
        return result.data.listAssets;
      }
      return result;
    },
    async getPackage({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_PACKAGE,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getPackage;
      }
      return result;
    },
    async listPackages({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_PACKAGES,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listPackages;
      }
      return result;
    },
    async getDeployment({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_DEPLOYMENT,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_DEPLOYMENT', result.data.getDeployment);
        return result.data.getDeployment;
      }
      return result;
    },
    async deleteDeployment({ dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: DELETE_DEPLOYMENT,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.deleteDeployment;
      }
      return result;
    },
    async getDeploymentDownloadURL({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_DEPLOYMENT_DOWNLOAD_URL,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getDeploymentDownloadURL;
      }
      return result;
    },
    async listDeployments({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_DEPLOYMENTS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_DEPLOYMENTS', result.data.listDeployments);
        return result.data.listDeployments;
      }
      return result;
    },
    async listAnalytics({ commit, dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ANALYTICS,
        variables: {},
      }, { root: true });
      if (result) {
        commit('SET_ANALYTICS', result.data.listAnalytics);
        return result.data.listAnalytics;
      }
      return result;
    },
    async getAnalytic({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_ANALYTIC,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ANALYTIC', result.data.getAnalytic);
        return result.data.getAnalytic;
      }
      return result;
    },
    async listAnalyticsCategories({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ANALYTIC_CATEGORIES,
        variables: {},
      }, { root: true });
      if (result) {
        return result.data.listAnalyticsCategories;
      }
      return result;
    },
    async listAnalyticsTags({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ANALYTIC_TAGS,
        variables: {},
      }, { root: true });
      if (result) {
        return result.data.listAnalyticsTags;
      }
      return result;
    },
    async listProfiles({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_PROFILES,
        variables: payload,
      }, { root: true });
      if (result) {
        result.data.listProfiles.items.forEach((p) => {
          if (typeof p.infoSync === 'string') {
            p.infoSync = JSON.parse(p.infoSync);
          }
        });
        commit('SET_PROFILES', result.data.listProfiles);
        return result.data.listProfiles;
      }
      return result;
    },
    async listAllProfiles({ dispatch }) {
      const items = [];
      const response = await dispatch('listProfiles', {
        next: null,
        direction: 'DESC',
        field: 'created',
      });
      if (response) {
        response.items.forEach(i => items.push(i));
        if (response.pageInfo.next) {
          const response2 = await dispatch('listProfiles', {
            next: response.pageInfo.next,
            direction: 'DESC',
            field: 'created',
          });
          if (response2) {
            response2.items.foreEach(i => items.push(i));
          }
        }
      }
      return items;
    },
    async getProfile({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_PROFILE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_PROFILE', result.data.getProfile);
        return result.data.getProfile;
      }
      return result;
    },
    async getOrganization({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_ORGANIZATION,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ORGANIZATION', result.data.getOrganization);
        return result.data.getOrganization;
      }
      return result;
    },
    async getConfig({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_CONFIG,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getConfig;
      }
      return result;
    },
    async getAlert({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_ALERT,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getAlert;
      }
      return result;
    },
    async listAlerts({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ALERTS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listAlerts;
      }
      return result;
    },
    async listAlertsStats({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ALERTS_STATS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listAlertsStats;
      }
      return result;
    },
    async listAlertsTags({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ALERTS_TAGS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listAlertsTags;
      }
      return result;
    },
    async getLog({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_LOG,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getLog;
      }
      return result;
    },
    async listLogs({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_LOGS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listLogs;
      }
      return result;
    },
    async listLogsStats({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_LOGS_STATS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listLogsStats;
      }
      return result;
    },
    async listLogsTags({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_LOGS_TAGS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listLogsTags;
      }
      return result;
    },
    async setProfileAnalytics({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: SET_PROFILE_ANALYTICS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_PROFILE', result.data.setProfileAnalytics);
        return result.data.setProfileAnalytics;
      }
      return result;
    },
    async setAssetProfile({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: SET_ASSET_PROFILE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ASSET', result.data.setAssetProfile);
        return result.data.setAssetProfile;
      }
      return result;
    },
    async deleteAsset({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: DELETE_ASSET,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ASSET', null);
        return result.data.deleteAsset;
      }
      return result;
    },
    async deleteActionConfigs({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: DELETE_ACTION_CONFIGS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ACTION_CONFIGS', null);
        return result.data.deleteActionConfigs;
      }
      return result;
    },
    async createActionConfigs({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: CREATE_ACTION_CONFIGS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ACTION_CONFIGS', result.data.createActionConfigs);
        return result.data.createActionConfigs;
      }
      return result;
    },
    async updateActionConfigs({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: UPDATE_ACTION_CONFIGS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ACTION_CONFIGS', result.data.updateActionConfigs);
        return result.data.updateActionConfigs;
      }
      return result;
    },
    async listActionConfigs({ commit, dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ACTION_CONFIGS,
        variables: payload,
      }, { root: true });
      if (result) {
        result.data.listActionConfigs.items.forEach((ac) => {
          if (typeof ac.logConfig === 'string') {
            ac.logConfig = JSON.parse(ac.logConfig);
          }
          if (typeof ac.alertConfig === 'string') {
            ac.alertConfig = JSON.parse(ac.alertConfig);
          }
          if (typeof ac.cacheConfig === 'string') {
            ac.cacheConfig = JSON.parse(ac.cacheConfig);
          }
        });
        commit('SET_ACTION_CONFIGSS', result.data.listActionConfigs);
        return result.data.listActionConfigs;
      }
      return result;
    },
    async getActionConfigs({ commit, dispatch }, payload) {
      // TODO: try to grab it from local list?
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_ACTION_CONFIGS,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ACTION_CONFIGS', result.data.getActionConfigs);
        return result.data.getActionConfigs;
      }
      return result;
    },
    async getMapKitKey({ dispatch }) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_MAPKIT_KEY,
        variables: {},
      }, { root: true });
      if (result) {
        // commit('SET_DEPLOYMENT', result.data.getDeployment);
        return result.data.getMapKitKey;
      }
      return result;
    },
    async getKeyValue({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: GET_KEYVALUE,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.getKeyValue;
      }
      return result;
    },
    async createOrUpdateKeyValue({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: CREATE_OR_UPDATE_KEYVALUE,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_KEYVALUE', result.data.createOrUpdateKeyValue);
        return result.data.createOrUpdateKeyValue;
      }
      return result;
    },
    async updateAsset({ commit, dispatch }, payload) {
      const result = await dispatch('doMutation', {
        client: Vue.$apollo.primary,
        query: UPDATE_ASSET,
        variables: payload,
      }, { root: true });
      if (result) {
        commit('SET_ASSET', result.data.updateAsset);
        return result.data.updateAsset;
      }
      return result;
    },
    async listAssetsStats({ dispatch }, payload) {
      const result = await dispatch('doQuery', {
        client: Vue.$apollo.primary,
        query: LIST_ASSETS_STATS,
        variables: payload,
      }, { root: true });
      if (result) {
        return result.data.listAssetsStats;
      }
      return result;
    },
  },
};

export default PrimaryStoreModule;
